import React, { useState } from "react";
import app_api from "../config/Api";
import "../styles/influencer.css";
export default function InfluencerDashboard() {
  const [loading, setLoading] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [data, setData] = useState(null); // State to store API response
  const [error, setError] = useState(""); // State to store error messages

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    setData(null);

    if (!promoCode.trim()) {
      setLoading(false);
      setError("Promo code is required.");
      return;
    }

    try {
      const response = await app_api.get(`api/v1/influencer/${promoCode}/`);
      setData(response.data);
      setLoading(false);
    } catch (err) {
      setError(
        err.response?.data?.error || "An error occurred. Please try again."
      );
      setLoading(false);
    }
  };

  return (
    <div className="influencerbody">
      <div className="container influencerdashboard">
        <h1>Influencer Data</h1>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={promoCode}
            onChange={(e) => setPromoCode(e.target.value)}
            placeholder="Enter promo code"
            className="input-field"
          />
          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? "Loading..." : "Search"}
          </button>
        </form>

        {error && <p className="error">{error}</p>}

        {data && (
          <div className="response-data">
            <h2>Subscribers:</h2>
            <table className="subscribers-table">
              <thead>
                <tr>
                  <th>User ID</th>
                  <th>Plan Name</th>
                  <th>Price</th>
                  <th>Purchased Date</th>
                </tr>
              </thead>
              <tbody>
                {data.subscribers.map((subscriber) => (
                  <tr key={subscriber.id}>
                    <td>{subscriber.id}</td>
                    <td>{subscriber.subscription_plan.plan_name}</td>
                    <td>{subscriber.subscription_plan.price}</td>
                    <td>
                      {new Date(subscriber.purchased_date).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
